import { Adapter as d } from "../../../../../adapter.js";
import { ShopSessionAddressModel as s } from "./address.model.js";
class i extends d {
  adapt(e) {
    return new s({
      latitude: e.latitude,
      longitude: e.longitude,
      address: e.address
    });
  }
  serialize(e) {
  }
}
export {
  i as ShopSessionAddressAdapter
};
//# sourceMappingURL=address.adapter.js.map
